import React, { useEffect, useRef, useState } from 'react';

import cx from 'classnames';

import './_panel.scss';
import { Button, Tooltip, InlineLoading } from '@carbon/react';
import { Information } from '@carbon/react/icons';
import { animated, useSpring } from 'react-spring';
import { useOnScreen } from '../Helpers';

export const PanelHeader = ({
  children,
  centered,
  header,
  small,
  helpText,
  iconForHelptext = <Information />,
  withSubtitle,
}) => {
  return (
    <div
      className={cx([
        header
          ? `micast-panel_container--header_header${small ? '-small' : ''}`
          : `micast-panel_container--header${small ? '-small' : ''}`,
        withSubtitle ? 'micast-panel_header_withSubtitle' : '',
        centered ? 'micast-panel_container--header_centered' : '',
      ])}>
      {children}
      {helpText && (
        <div className="micast-panel_headerHelp">
          <Tooltip label={helpText} direction="top" align="left">
            {iconForHelptext}
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export const PanelLabel = ({ children, centered, bold, semi }) => {
  return (
    <div
      className={cx([
        'micast-panel_container--label',
        centered ? 'micast-panel_container--header_centered' : '',
        bold ? 'micast-panel_container--label_bold' : '',
        semi ? 'micast-panel_container--label_semi' : '',
      ])}>
      {children}
    </div>
  );
};

export const PanelFooter = ({ children }) => {
  return <div className="micast-panel_container--footer">{children}</div>;
};

export const PanelIcon = ({ children, showRed }) => {
  return (
    <div className="micast-panel_container--icon_pre">
      <div className="micast-panel_container--icon">
        <div className="micast-panel_container--icon_container">
          <div
            className={`micast-panel_container--icon_inner ${
              showRed === true ? 'micast-panel_container--icon_red' : ''
            }`}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export const PanelProgress = ({ max = 10, current = 0 }) => {
  const ref = useRef();
  const onScreen = useOnScreen(ref);

  const [currentValue, setValue] = useState(0);

  useEffect(() => {
    if (onScreen) {
      setValue(current || 0);
    } else {
      setValue(0);
    }
  }, [onScreen, current]);

  const props = useSpring({
    width: `${(currentValue * 100) / (max || 100)}%`,
    from: { width: '0%' },
  });

  return (
    <div className="micast-panel_progress" ref={ref}>
      <animated.div
        className="micast-panel_progress_status"
        style={{ width: props.width }}>
        &nbsp;
      </animated.div>
    </div>
  );
};

export const Panel = ({ children, doubleHeight, small, halfSize }) => {
  return (
    <div
      className={cx([
        small ? 'micast-panel_container-small' : 'micast-panel_container',
        doubleHeight ? 'micast-panel_container_doubleHeight' : '',
        halfSize ? 'micast-panel_container_halfSize' : '',
      ])}>
      {children}
    </div>
  );
};

/* eslint-disable react/no-children-prop */
/// TODO: Render icon doesnt work
export const PanelLink = ({ children, onClick, _icon }) => {
  return (
    <div className="micast-panel_container--link">
      <Button href="#" onClick={() => onClick()} children={children}>

      </Button>
    </div>
  );
};

export const PanelHelp = ({ children }) => {
  return <div className="micast-panel_help--container">{children}</div>;
};

export const PanelHelpLeft = ({ children }) => {
  return <div className="micast-panel_help--left">{children}</div>;
};

export const PanelHelpRight = ({ children }) => {
  return <div className="micast-panel_help--right">{children}</div>;
};


export const PanelStatistics = ({ children }) => {
  return <div className="micast-panel_statistics">{children}</div>;
}

export const PanelStatistic = ({ children, isLoading = false }) => {
  return <div className="micast-panel_statistics--container">{isLoading && <InlineLoading />}{children}</div>;
}

export const PanelStatisticsFooter = ({ children }) => {
  return <div className="micast-panel_statistics--footer">{children}</div>;
}

export const PanelValue = ({ children, isLoading = false }) => {
  if (isLoading) {
    return <InlineLoading/>
  }

  return <div className={`micast-panel_statistics--value ${!isLoading && "micast-panel_statistics--value--animation"}`}>{children}</div>;
}
